import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {useAdminBucket} from "../../../components/utils";
import AudienceForm from "../../../components/data_products/audiences/AudienceForm";
import {
  useGetDataVendorAudienceAggregationOptionsQuery,
  useGetDataVendorAudienceQuery,
  useGetDataVendorAudiencesQuery,
  useUpdateDataVendorAudienceMutation
} from "../../../api/dataVendorAudienceApiSlice";
import {useControlledTabs} from "../../../components/Tabs";

export default function EditDataVendorAudience(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey, audienceId } = useParams();
  const bucket = useAdminBucket(dataVendorKey)
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [tabProps,] = useControlledTabs("audience", props)
  const { data: audience, isSuccess } = useGetDataVendorAudienceQuery([dataVendorKey, audienceId])
  const { data: aggregationOptions = [] } = useGetDataVendorAudienceAggregationOptionsQuery(dataVendorKey)
  const { data: audiences = [] } = useGetDataVendorAudiencesQuery(dataVendorKey)

  const goToAudience = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}/audiences/${audienceId}`,
    state: {activeTab: tabProps.active}
  })

  const [updateAudience] = useUpdateDataVendorAudienceMutation()

  const submitProps = {
    handleSubmit: (data) => {
      updateAudience({...data, key: audienceId, dataVendorId: dataVendorKey}).unwrap()
        .then(goToAudience)
        .catch(error => {})
    },
    errors: {}
  }

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title
        main={t("menu.audiences")}
        sub={audience.name}
        group={false}
        onBack={goToAudience}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToAudience} />
      </Title>
      <AudienceForm
        bucket={bucket}
        audience={audience}
        {...submitProps}
        setSubmitButtonProps={setSubmitButtonProps}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
        tabProps={tabProps}
      />
    </>
  )
}

